import React, { useState } from 'react';
import ComparisonSelector from './ComparisonSelector';
import { getOperator, getValue } from './utils';
export var useComparisonFilter = function (column, onFilterChange) {
    var _a = useState(getOperator(column.filter)), comparisonValue = _a[0], setComparisonValue = _a[1];
    var filterValue = getValue(column.filter);
    var doFilterChange = function (filterComparisonValue, filterNumberValue) {
        var newFilterValue = filterNumberValue ? "" + filterComparisonValue + filterNumberValue : undefined;
        onFilterChange(column, newFilterValue);
    };
    var onComparisonOperatorChange = function (event) {
        var newComparisonValue = event.target.value;
        setComparisonValue(newComparisonValue);
        doFilterChange(newComparisonValue, filterValue);
    };
    var onFilterValueChange = function (newFilterValue) {
        doFilterChange(comparisonValue, newFilterValue);
    };
    var comparisonSelector = (React.createElement(ComparisonSelector, { name: column.name, onChange: onComparisonOperatorChange, value: comparisonValue, options: column.options, disabled: !column.filterable }));
    return [
        comparisonSelector,
        filterValue,
        onFilterValueChange,
    ];
};
//# sourceMappingURL=useComparisonFilter.js.map